<template>
  <md-dialog
    id="modUploadComponents"
    ref="moduleModal"
    md-title
    :md-esc-to-close="false"
    :md-click-outside-to-close="false"
    class="dashboard modals"
  >
    <md-dialog-title>
      <span>Upload de Arquivo XML</span>
      <button
        id="mod_btnClose"
        class="close-button btn-transparent"
        @click="closeDialog"
      >
        <md-icon>clear</md-icon>
      </button>
    </md-dialog-title>

    <md-dialog-content>
      <component
        :is="'upload-xml'"
        @closeModalContainer="closeDialog"
      />
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UploadXml from './UploadXml'

export default {
  name: 'UploadXmlModal',
  components: {
    'upload-xml': UploadXml
  },
  methods: {
    ...mapActions(['setUploadModalVisible']),
    ...mapActions(['setInitialUploadStatus']),
    ...mapActions(['setUploadStatusMessage']),
    openDialog () {
      this.$refs.moduleModal.open()
      this.$analytics.pushAnalyticsEvent('vpageview', {
        'page': 'modal/upload-xml',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    closeDialog () {
      this.setUploadModalVisible(false)
      this.setUploadStatusMessage(null)
      this.$refs.moduleModal.close()
    }
  },
  watch: {
    isUploadModalVisible () {
      if (this.isUploadModalVisible) {
        this.openDialog()
      } else {
        this.closeDialog()
      }
    }
  },
  computed: {
    ...mapGetters(['profile']),
    ...mapGetters(['isUploadModalVisible'])
  }
}
</script>

<style>
  .dashboard.modals .md-dialog {
    min-width: 660px;
    min-height: 480px;
  }
</style>
